import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/tiemposConsulta';

import TiemposConsulta from './TiemposConsulta';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.tiemposConsulta,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(TiemposConsulta);
